import { Component, ElementRef, Input, OnInit, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, ValidatorFn } from '@angular/forms';
import { formDateValidator } from '../../utils/form-date-validator.util';
import { formCompetenceDateValidator } from '../../utils/form-competence-date-validator.util';

@Component({
  selector: 'app-datepicker-input',
  templateUrl: './datepicker-input.component.html',
  styleUrls: ['./datepicker-input.component.scss']
})
export class DatepickerInputComponent implements ControlValueAccessor, OnInit {
  @ViewChild('inputData') input: ElementRef<HTMLInputElement>;
  @Input() id: string;
  @Input() name: string;
  @Input() mandatory: boolean;
  @Input() helpTooltipText: string;
  @Input() isDisabled: boolean;
  @Input() month = false;
  @Input() inputMask: string;
  public value: string;
  
  get isInvalid(): boolean {
    return this.controlDirective && this.controlDirective.control.dirty && !this.controlDirective.control.valid;
  }

  constructor(@Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;
  }

  ngOnInit(): void {
    const control = this.controlDirective.control;

    const validators = control.validator ? [control.validator, ...this.getValidators()] : this.getValidators();

    control.setValidators(validators);

    control.updateValueAndValidity();
  }

  private getValidators(): ValidatorFn[] {
    if(this.month)
      return [formCompetenceDateValidator];
    else
      return [formDateValidator];
  }

  private onChange: (value: string) => void;
  private onTouched: () => void;

  public writeValue(value: string): void {
    this.value = value;
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public handleInput(): void {
    this.onChange(this.value);
  }

  public mascara(): string {
    if(this.input?.nativeElement.type == 'text'){
      return this.inputMask;
    }
    return '';
  }

  public onBlur(): void {
    this.onTouched();
  }
}
